import React from 'react';
import { X, Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export const Comparativa: React.FC = () => {
  const fisicos = ['Comprar cada libro por separado', 'Gastar mucho más dinero', 'Esperar envíos', 'Menos variedad', 'Si se rompe, vuelves a comprar'];
  const digital = ['Todo en un solo lugar', 'Descarga inmediata', 'Más de 50 libros', 'Más de 2.500 páginas', 'Imprime las veces que quieras', 'Acceso permanente'];
  return <section className="py-8 px-4 bg-cream-dark/50" data-id="element-25">
      <div className="max-w-3xl mx-auto" data-id="element-26">
        <h2 className="font-rounded font-bold text-[2rem] sm:text-4xl text-violet text-center leading-tight mb-8" data-id="element-27">
          La diferencia es <span className="text-gold-dark" data-id="element-28">enorme</span>
        </h2>

        <div className="grid grid-cols-2 gap-3 mb-6" data-id="element-29">
          {/* Bad */}
          <div className="bg-white rounded-2xl border-2 border-cream-dark p-4 sm:p-5 opacity-90" data-id="element-30">
            <h3 className="font-rounded font-bold text-base sm:text-xl text-gray-500 mb-3 text-center leading-tight" data-id="element-31">
              Libros físicos
            </h3>
            <ul className="space-y-2.5" data-id="element-32">
              {fisicos.map((item, idx) => <li key={idx} className="flex items-start gap-1.5 text-gray-500" data-id="element-33">
                  <X className="text-red-500 w-4 h-4 flex-shrink-0 mt-1" strokeWidth={3.5} data-id="element-34" />
                  <span className="text-xs sm:text-sm leading-snug font-semibold" data-id="element-35">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Good */}
          <div className="bg-violet rounded-2xl border-[3px] border-gold p-4 sm:p-5 shadow-xl relative" data-id="element-36">
            <h3 className="font-rounded font-bold text-base sm:text-xl text-yellow mb-3 text-center leading-tight" data-id="element-37">
              Biblioteca Mágica
            </h3>
            <ul className="space-y-2.5" data-id="element-38">
              {digital.map((item, idx) => <li key={idx} className="flex items-start gap-1.5 text-cream" data-id="element-39">
                  <Check className="text-yellow w-4 h-4 flex-shrink-0 mt-1" strokeWidth={3.5} data-id="element-40" />
                  <span className="text-xs sm:text-sm leading-snug font-bold" data-id="element-41">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <CTAButton data-id="element-42" />
      </div>
    </section>;
};